var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 78,
    viewBox: "0 0 103 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M58.4022 57.6895L34.0361 43.582L15.4005 54.3566L23.848 59.2483L22.7716 59.8682L21.4058 59.0813L20.3888 59.6677L19.5612 59.1889L17.4864 58.6842L17.4011 58.7324L11.8783 55.5443L11.5109 55.7558L8.39692 53.9594L8.76437 53.618L7.67318 52.9907L6.7119 53.8889L7.2946 54.223L3.26762 57.8899L4.4887 58.5951L0.532227 61.5829L1.9426 62.0431L4.98604 64.6375L3.89857 65.4206L7.33543 67.4025L9.13552 68.4418L9.32109 68.5494L8.79406 68.8537L23.8962 77.6055L58.4022 57.6895Z",
    fill: "url(#paint0_linear_188_8464)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3274 52.3867L57.0066 52.0378L44.8477 45.0156L44.1685 45.3682L56.3274 52.3867Z",
    fill: "#B2B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3276 54.3162L57.0068 53.9636V52.0373L56.3276 52.3862V54.3162Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1685 45.3672L56.3274 52.3857V54.3156L44.1685 47.2935V45.3672Z",
    fill: "#5A5C54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2029 50.9721C34.2029 51.7515 34.4739 52.312 34.923 52.6163C35.5279 53.0209 36.8233 53.7261 36.8233 53.7261C38.6456 52.6757 42.2198 49.0236 42.2198 47.2012C42.2198 46.4107 40.5162 45.8094 40.0486 45.5088C39.4436 45.1191 38.5268 45.1785 37.495 45.7723C35.6727 46.8227 34.1992 49.1535 34.1992 50.9721H34.2029Z",
    fill: "url(#paint1_linear_188_8464)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9883 52.0099C35.9883 53.8322 37.4655 54.4558 39.2841 53.4054C41.1065 52.355 42.5799 50.0242 42.5799 48.2056C42.5799 46.3869 41.1027 45.7597 39.2841 46.81C37.4618 47.8604 35.9883 50.1912 35.9883 52.0099Z",
    fill: "#424852"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3113 52.1596C36.3113 52.939 36.5823 53.4995 37.0314 53.8038C37.6363 54.2084 38.9316 54.9136 38.9316 54.9136C40.754 53.8632 44.3282 50.2111 44.3282 48.3887C44.3282 47.5982 42.6246 46.9969 42.157 46.6963C41.552 46.3066 40.6352 46.366 39.6034 46.9598C37.7811 48.0102 36.3076 50.341 36.3076 52.1596H36.3113Z",
    fill: "url(#paint2_linear_188_8464)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0928 53.2013C38.0928 55.0236 39.57 55.6472 41.3886 54.5968C43.211 53.5465 44.6844 51.2156 44.6844 49.397C44.6844 47.5783 43.2072 46.9511 41.3886 48.0014C39.5662 49.0518 38.0928 51.3826 38.0928 53.2013Z",
    fill: "#424852"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0688 52.4609C39.0688 53.6708 40.0487 54.0828 41.2586 53.385C42.4686 52.6873 43.4484 51.1433 43.4484 49.9333C43.4484 48.7234 42.4686 48.3114 41.2586 49.0091C40.0487 49.7069 39.0688 51.2509 39.0688 52.4609Z",
    fill: "url(#paint3_linear_188_8464)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2021 52.5607C39.2021 53.7706 40.182 54.1826 41.3919 53.4848C42.6019 52.7871 43.5817 51.2431 43.5817 50.0331C43.5817 48.8232 42.6019 48.4112 41.3919 49.109C40.182 49.8067 39.2021 51.3507 39.2021 52.5607Z",
    fill: "#D7D9DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3516 50.1616C43.3516 51.2454 42.472 52.6335 41.3882 53.2607C40.3081 53.8843 39.4248 53.5131 39.4248 52.4294C39.4248 52.3106 39.4359 52.1844 39.4582 52.0619C39.6215 51.0524 40.4269 49.8907 41.3882 49.3302C41.4661 49.2857 41.5478 49.2449 41.622 49.2115C42.5981 48.7624 43.3516 49.1558 43.3516 50.1616Z",
    fill: "url(#paint4_linear_188_8464)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.398 50.0525V50.0673C42.398 50.8913 41.7337 51.9379 40.9097 52.4093C40.7612 52.4984 40.6128 52.5578 40.4754 52.5986C40.0189 52.7211 39.6515 52.58 39.5067 52.2126C39.4845 52.168 39.4696 52.1198 39.4585 52.0678C39.4808 51.9231 39.5179 51.7709 39.5661 51.6225C39.8222 50.8393 40.4086 50.0302 41.1101 49.5217C41.1992 49.4549 41.2957 49.3955 41.3885 49.3362C41.4553 49.299 41.5184 49.2657 41.5852 49.236C41.6 49.2285 41.6112 49.2211 41.6223 49.2174C42.0788 49.1988 42.3906 49.4995 42.398 50.0562V50.0525Z",
    fill: "#E3E5E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2646 49.843C42.2646 50.6484 41.2476 52.1145 40.4385 52.5933C40.4348 52.597 40.4311 52.597 40.4274 52.6007C40.4274 52.6007 40.4163 52.597 40.394 52.5896C40.3569 52.5822 40.3235 52.5747 40.2901 52.5562C40.2789 52.5524 40.2641 52.5487 40.2492 52.5413C40.0711 52.4782 39.7853 52.3632 39.5106 52.211C39.4884 52.1665 39.4735 52.1182 39.4624 52.0662C39.4847 51.9215 39.5218 51.7693 39.57 51.6209C39.8261 50.8377 40.4125 50.0286 41.114 49.5201C41.2031 49.4533 41.2996 49.394 41.3924 49.3346C41.4592 49.2975 41.5223 49.2641 41.5891 49.2344C41.8489 49.4237 42.0642 49.6352 42.1829 49.754H42.1867C42.2386 49.8134 42.2683 49.8468 42.2683 49.8468L42.2646 49.843Z",
    fill: "url(#paint5_linear_188_8464)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4535 50.3808C42.4535 51.0897 41.8819 51.9916 41.173 52.4036C40.4679 52.8119 39.8926 52.5669 39.8926 51.8617C39.8926 51.7838 39.9 51.7021 39.9148 51.6205C40.0188 50.9598 40.5458 50.2027 41.173 49.8389C41.225 49.8092 41.277 49.7833 41.3252 49.761C41.9636 49.4678 42.4535 49.7239 42.4535 50.3808Z",
    fill: "#D9DBDD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8447 50.8053C41.8447 51.1505 41.5664 51.5922 41.2212 51.7889C40.876 51.9856 40.5977 51.8705 40.5977 51.5254C40.5977 51.4882 40.5977 51.4474 40.6088 51.4066C40.6608 51.0837 40.9168 50.7162 41.2212 50.5381C41.2472 50.5232 41.2732 50.5121 41.2954 50.501C41.6072 50.3562 41.8447 50.4824 41.8447 50.8016V50.8053Z",
    fill: "url(#paint6_linear_188_8464)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3103 50.8914C41.3103 51.0287 41.199 51.2069 41.0617 51.2848C40.9243 51.3628 40.813 51.3182 40.813 51.1809C40.813 51.1661 40.813 51.1512 40.8167 51.1327C40.839 51.0027 40.9392 50.858 41.0617 50.7838C41.0728 50.7763 41.0802 50.7726 41.0914 50.7689C41.2138 50.7132 41.3103 50.7615 41.3103 50.8914Z",
    fill: "#E3E5E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6316 55.3454C26.6316 56.1248 26.9026 56.6852 27.3517 56.9896C27.9567 57.3941 29.252 58.0993 29.252 58.0993C31.0743 57.049 34.6485 53.3968 34.6485 51.5745C34.6485 50.7839 32.9449 50.1827 32.4773 49.882C31.8723 49.4923 30.9556 49.5517 29.9238 50.1455C28.1014 51.1959 26.6279 53.5267 26.6279 55.3454H26.6316Z",
    fill: "url(#paint7_linear_188_8464)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4131 56.3851C28.4131 58.2074 29.8903 58.831 31.7089 57.7806C33.5313 56.7302 35.0047 54.3994 35.0047 52.5808C35.0047 50.7621 33.5275 50.1349 31.7089 51.1853C29.8866 52.2356 28.4131 54.5664 28.4131 56.3851Z",
    fill: "#424852"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7361 56.5331C28.7361 57.3125 29.0071 57.8729 29.4562 58.1773C30.0611 58.5818 31.3565 59.287 31.3565 59.287C33.1788 58.2367 36.753 54.5846 36.753 52.7622C36.753 51.9717 35.0494 51.3704 34.5818 51.0698C33.9768 50.68 33.06 50.7394 32.0282 51.3333C30.2059 52.3836 28.7324 54.7145 28.7324 56.5331H28.7361Z",
    fill: "url(#paint8_linear_188_8464)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5215 57.5743C30.5215 59.3967 31.9987 60.0202 33.8173 58.9699C35.6397 57.9195 37.1131 55.5887 37.1131 53.77C37.1131 51.9514 35.6359 51.3241 33.8173 52.3745C31.995 53.4249 30.5215 55.7557 30.5215 57.5743Z",
    fill: "#424852"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4937 56.8343C31.4937 58.0443 32.4735 58.4563 33.6834 57.7585C34.8934 57.0607 35.8732 55.5167 35.8732 54.3068C35.8732 53.0968 34.8934 52.6849 33.6834 53.3826C32.4735 54.0804 31.4937 55.6244 31.4937 56.8343Z",
    fill: "url(#paint9_linear_188_8464)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6309 56.9359C31.6309 58.1458 32.6107 58.5578 33.8207 57.8601C35.0306 57.1623 36.0104 55.6183 36.0104 54.4083C36.0104 53.1984 35.0306 52.7864 33.8207 53.4842C32.6107 54.1819 31.6309 55.7259 31.6309 56.9359Z",
    fill: "#D7D9DB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7803 54.5351C35.7803 55.6189 34.9007 57.007 33.8169 57.6342C32.7369 58.2578 31.8535 57.8866 31.8535 56.8028C31.8535 56.6841 31.8647 56.5579 31.8869 56.4354C32.0502 55.4259 32.8556 54.2642 33.8169 53.7037C33.8948 53.6592 33.9765 53.6184 34.0507 53.585C35.0269 53.1359 35.7803 53.5293 35.7803 54.5351Z",
    fill: "url(#paint10_linear_188_8464)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8267 54.4199V54.4347C34.8267 55.2587 34.1624 56.3053 33.3384 56.7767C33.1899 56.8658 33.0415 56.9252 32.9042 56.966C32.4476 57.0885 32.0802 56.9474 31.9355 56.58C31.9132 56.5355 31.8983 56.4872 31.8872 56.4352C31.9095 56.2905 31.9466 56.1383 31.9948 55.9898C32.2509 55.2067 32.8373 54.3976 33.5388 53.8891C33.6279 53.8223 33.7244 53.763 33.8172 53.7036C33.884 53.6665 33.9471 53.633 34.0139 53.6033C34.0287 53.5959 34.0399 53.5885 34.051 53.5848C34.5075 53.5662 34.8193 53.8669 34.8267 54.4236V54.4199Z",
    fill: "#E3E5E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6928 54.2183C34.6928 55.0237 33.6759 56.4897 32.8668 56.9685C32.863 56.9722 32.8593 56.9722 32.8556 56.9759C32.8556 56.9759 32.8445 56.9722 32.8222 56.9648C32.7851 56.9574 32.7517 56.95 32.7183 56.9314C32.7072 56.9277 32.6923 56.924 32.6775 56.9166C32.4993 56.8535 32.2135 56.7384 31.9389 56.5862C31.9166 56.5417 31.9018 56.4934 31.8906 56.4415C31.9129 56.2967 31.95 56.1445 31.9983 55.9961C32.2544 55.213 32.8408 54.4039 33.5422 53.8954C33.6313 53.8286 33.7278 53.7692 33.8206 53.7098C33.8874 53.6727 33.9505 53.6393 34.0173 53.6096C34.2771 53.7989 34.4924 54.0104 34.6112 54.1292H34.6149C34.6668 54.1886 34.6965 54.222 34.6965 54.222L34.6928 54.2183Z",
    fill: "url(#paint11_linear_188_8464)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8788 54.7539C34.8788 55.4628 34.3072 56.3647 33.5983 56.7766C32.8932 57.1849 32.3179 56.94 32.3179 56.2348C32.3179 56.1568 32.3253 56.0752 32.3401 55.9935C32.4441 55.3329 32.9711 54.5757 33.5983 54.212C33.6503 54.1823 33.7023 54.1563 33.7505 54.134C34.3889 53.8408 34.8788 54.0969 34.8788 54.7539Z",
    fill: "#D9DBDD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.27 55.1805C34.27 55.5257 33.9917 55.9674 33.6465 56.1641C33.3013 56.3608 33.0229 56.2457 33.0229 55.9006C33.0229 55.8634 33.0229 55.8226 33.0341 55.7818C33.086 55.4589 33.3421 55.0915 33.6465 54.9133C33.6725 54.8985 33.6984 54.8873 33.7207 54.8762C34.0325 54.7314 34.27 54.8576 34.27 55.1768V55.1805Z",
    fill: "url(#paint12_linear_188_8464)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.739 55.2649C33.739 55.4022 33.6277 55.5803 33.4904 55.6583C33.353 55.7362 33.2417 55.6917 33.2417 55.5544C33.2417 55.5395 33.2417 55.5247 33.2454 55.5061C33.2677 55.3762 33.3679 55.2315 33.4904 55.1572C33.5015 55.1498 33.5089 55.1461 33.5201 55.1424C33.6425 55.0867 33.739 55.135 33.739 55.2649Z",
    fill: "#E3E5E6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5976 51.5622L45.0669 51.8666V48.5114L45.5976 48.207V51.5622Z",
    fill: "#725986"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5215 52.4164C39.5215 53.4482 40.3603 53.8045 41.3921 53.2069C42.4239 52.6094 43.2627 51.2881 43.2627 50.2563C43.2627 49.2245 42.4239 48.8682 41.3921 49.4657C40.3603 50.0633 39.5215 51.3846 39.5215 52.4164Z",
    fill: "#ADD1B9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8589 51.2132L33.8167 61.5868L26.8242 57.1293L43.6819 47.3977L46.3282 46.8633L53.8589 51.2132Z",
    fill: "#878787"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8591 51.2132L50.6746 51.859L43.6821 47.3977L46.3284 46.8633L53.8591 51.2132Z",
    fill: "#747474"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3105 53.4007L42.4833 48.6797L47.1635 51.3371L38.9871 56.0582L34.3105 53.4007Z",
    fill: "#A4A4A4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9126 51.7876C43.9126 52.7897 42.6655 53.6025 41.1252 53.6025C39.585 53.6025 38.3379 52.7897 38.3379 51.7876C38.3379 50.7855 39.585 49.9727 41.1252 49.9727C42.6655 49.9727 43.9126 50.7855 43.9126 51.7876Z",
    fill: "#878787"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8591 52.7497L33.8169 64.3185V61.5868L50.6746 51.8589L53.8591 51.2131V52.7497Z",
    fill: "#4F4F4F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9873 56.057L47.1638 51.3359L47.6574 52.3084L38.4937 57.5973L38.9873 56.057Z",
    fill: "#747474"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3304 57.4409C45.3304 58.2203 45.6013 58.7807 46.0504 59.0851C46.6554 59.4896 47.9507 60.1948 47.9507 60.1948C49.7731 59.1445 53.3472 55.4923 53.3472 53.67C53.3472 52.8794 51.6437 52.2782 51.176 51.9775C50.571 51.5878 49.6543 51.6472 48.6225 52.2411C46.8001 53.2914 45.3267 55.6222 45.3267 57.4409H45.3304Z",
    fill: "url(#paint13_linear_188_8464)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1157 58.4786C47.1157 60.301 48.5929 60.9245 50.4115 59.8742C52.2339 58.8238 53.7074 56.493 53.7074 54.6743C53.7074 52.8557 52.2302 52.2284 50.4115 53.2788C48.5892 54.3292 47.1157 56.66 47.1157 58.4786Z",
    fill: "#424852"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4383 58.6264C47.4383 59.4058 47.7092 59.9663 48.1583 60.2706C48.7633 60.6752 50.0586 61.3804 50.0586 61.3804C51.881 60.33 55.4552 56.6779 55.4552 54.8555C55.4552 54.065 53.7516 53.4637 53.2839 53.1631C52.6789 52.7734 51.7622 52.8328 50.7304 53.4266C48.908 54.477 47.4346 56.8078 47.4346 58.6264H47.4383Z",
    fill: "url(#paint14_linear_188_8464)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2202 59.6681C49.2202 61.4904 50.6974 62.114 52.516 61.0636C54.3384 60.0133 55.8119 57.6824 55.8119 55.8638C55.8119 54.0451 54.3347 53.4179 52.516 54.4682C50.6937 55.5186 49.2202 57.8494 49.2202 59.6681Z",
    fill: "#424852"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1963 58.9298C50.1963 60.1398 51.1761 60.5518 52.3861 59.854C53.596 59.1562 54.5759 57.6122 54.5759 56.4023C54.5759 55.1923 53.596 54.7803 52.3861 55.4781C51.1761 56.1759 50.1963 57.7199 50.1963 58.9298Z",
    fill: "url(#paint15_linear_188_8464)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3296 59.0275C50.3296 60.2374 51.3094 60.6494 52.5194 59.9516C53.7293 59.2539 54.7092 57.7099 54.7092 56.4999C54.7092 55.29 53.7293 54.878 52.5194 55.5758C51.3094 56.2735 50.3296 57.8175 50.3296 59.0275Z",
    fill: "#D7D9DB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4829 56.6302C54.4829 57.7139 53.6033 59.102 52.5195 59.7293C51.4395 60.3528 50.5562 59.9817 50.5562 58.8979C50.5562 58.7791 50.5673 58.653 50.5896 58.5305C50.7529 57.5209 51.5583 56.3592 52.5195 55.7988C52.5975 55.7543 52.6754 55.7134 52.7534 55.68C53.7295 55.2309 54.4829 55.6244 54.4829 56.6302Z",
    fill: "url(#paint16_linear_188_8464)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5294 56.5156V56.5304C53.5294 57.3544 52.865 58.401 52.041 58.8724C51.8926 58.9615 51.7441 59.0209 51.6068 59.0617C51.1503 59.1842 50.7828 59.0431 50.6381 58.6757C50.6158 58.6312 50.601 58.5829 50.5898 58.5309C50.6121 58.3862 50.6492 58.234 50.6975 58.0856C50.9536 57.3024 51.54 56.4933 52.2415 55.9848C52.3305 55.918 52.427 55.8587 52.5198 55.7993C52.5866 55.7622 52.6497 55.7287 52.7165 55.6991C52.7314 55.6916 52.7425 55.6842 52.7537 55.6805C53.2102 55.6619 53.5219 55.9626 53.5294 56.5193V56.5156Z",
    fill: "#E3E5E6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M53.392 56.312C53.392 57.1174 52.3751 58.5835 51.566 59.0623C51.5623 59.066 51.5586 59.066 51.5548 59.0697C51.5548 59.0697 51.5437 59.066 51.5214 59.0585C51.4843 59.0511 51.4509 59.0437 51.4175 59.0251C51.4064 59.0214 51.3915 59.0177 51.3767 59.0103C51.1985 58.9472 50.9127 58.8321 50.6381 58.68C50.6158 58.6354 50.601 58.5872 50.5898 58.5352C50.6121 58.3905 50.6492 58.2383 50.6975 58.0898C50.9536 57.3067 51.54 56.4976 52.2415 55.9891C52.3305 55.9223 52.427 55.8629 52.5198 55.8035C52.5866 55.7664 52.6497 55.733 52.7165 55.7033C52.9764 55.8926 53.1916 56.1042 53.3104 56.2229H53.3141C53.3661 56.2823 53.3957 56.3157 53.3957 56.3157L53.392 56.312Z",
    fill: "url(#paint17_linear_188_8464)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.581 56.8496C53.581 57.5585 53.0094 58.4604 52.3005 58.8723C51.5953 59.2806 51.02 59.0356 51.02 58.3305C51.02 58.2525 51.0274 58.1709 51.0423 58.0892C51.1462 57.4286 51.6733 56.6714 52.3005 56.3077C52.3525 56.278 52.4044 56.252 52.4527 56.2297C53.091 55.9365 53.581 56.1926 53.581 56.8496Z",
    fill: "#D9DBDD"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9722 57.2741C52.9722 57.6193 52.6938 58.0609 52.3486 58.2576C52.0035 58.4544 51.7251 58.3393 51.7251 57.9941C51.7251 57.957 51.7251 57.9162 51.7362 57.8753C51.7882 57.5524 52.0443 57.185 52.3486 57.0069C52.3746 56.992 52.4006 56.9809 52.4229 56.9697C52.7346 56.825 52.9722 56.9512 52.9722 57.2704V57.2741Z",
    fill: "url(#paint18_linear_188_8464)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4378 57.3582C52.4378 57.4955 52.3264 57.6737 52.1891 57.7516C52.0518 57.8295 51.9404 57.785 51.9404 57.6477C51.9404 57.6328 51.9404 57.618 51.9441 57.5994C51.9664 57.4695 52.0666 57.3248 52.1891 57.2505C52.2002 57.2431 52.2077 57.2394 52.2188 57.2357C52.3413 57.18 52.4378 57.2283 52.4378 57.3582Z",
    fill: "#E3E5E6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7586 61.812C37.7586 62.5914 38.0295 63.1518 38.4786 63.4562C39.0836 63.8607 40.3789 64.5659 40.3789 64.5659C42.2013 63.5156 45.7755 59.8634 45.7755 58.0411C45.7755 57.2505 44.0719 56.6493 43.6042 56.3486C42.9993 55.9589 42.0825 56.0183 41.0507 56.6121C39.2284 57.6625 37.7549 59.9933 37.7549 61.812H37.7586Z",
    fill: "url(#paint19_linear_188_8464)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5439 62.8517C39.5439 64.674 41.0211 65.2975 42.8398 64.2472C44.6621 63.1968 46.1356 60.866 46.1356 59.0474C46.1356 57.2287 44.6584 56.6015 42.8398 57.6518C41.0174 58.7022 39.5439 61.033 39.5439 62.8517Z",
    fill: "#424852"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8631 62.9995C39.8631 63.7789 40.134 64.3393 40.5831 64.6437C41.1881 65.0482 42.4834 65.7534 42.4834 65.7534C44.3058 64.703 47.88 61.0509 47.88 59.2286C47.88 58.438 46.1764 57.8368 45.7087 57.5361C45.1037 57.1464 44.187 57.2058 43.1552 57.7996C41.3328 58.85 39.8594 61.1808 39.8594 62.9995H39.8631Z",
    fill: "url(#paint20_linear_188_8464)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6484 64.0392C41.6484 65.8615 43.1256 66.4851 44.9443 65.4347C46.7666 64.3843 48.2401 62.0535 48.2401 60.2349C48.2401 58.4162 46.7629 57.789 44.9443 58.8393C43.1219 59.8897 41.6484 62.2205 41.6484 64.0392Z",
    fill: "#424852"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6206 63.3009C42.6206 64.5109 43.6005 64.9228 44.8104 64.2251C46.0204 63.5273 47.0002 61.9833 47.0002 60.7734C47.0002 59.5634 46.0204 59.1514 44.8104 59.8492C43.6005 60.547 42.6206 62.091 42.6206 63.3009Z",
    fill: "url(#paint21_linear_188_8464)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7578 63.3986C42.7578 64.6085 43.7377 65.0205 44.9476 64.3227C46.1576 63.625 47.1374 62.081 47.1374 60.871C47.1374 59.6611 46.1576 59.2491 44.9476 59.9469C43.7377 60.6446 42.7578 62.1886 42.7578 63.3986Z",
    fill: "#D7D9DB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9073 61.0017C46.9073 62.0855 46.0276 63.4736 44.9439 64.1008C43.8638 64.7244 42.9805 64.3532 42.9805 63.2694C42.9805 63.1507 42.9916 63.0245 43.0139 62.902C43.1772 61.8925 43.9826 60.7308 44.9439 60.1703C45.0218 60.1258 45.1035 60.085 45.1777 60.0516C46.1538 59.6025 46.9073 59.9959 46.9073 61.0017Z",
    fill: "url(#paint22_linear_188_8464)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9537 60.8867V60.9015C45.9537 61.7255 45.2893 62.7721 44.4654 63.2435C44.3169 63.3326 44.1684 63.3919 44.0311 63.4328C43.5746 63.5553 43.2072 63.4142 43.0624 63.0468C43.0401 63.0022 43.0253 62.954 43.0142 62.902C43.0364 62.7573 43.0735 62.6051 43.1218 62.4566C43.3779 61.6735 43.9643 60.8644 44.6658 60.3559C44.7549 60.2891 44.8514 60.2297 44.9442 60.1704C45.011 60.1332 45.0741 60.0998 45.1409 60.0701C45.1557 60.0627 45.1668 60.0553 45.178 60.0516C45.6345 60.033 45.9463 60.3337 45.9537 60.8904V60.8867Z",
    fill: "#E3E5E6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8198 60.6829C45.8198 61.4883 44.8028 62.9543 43.9937 63.4331C43.99 63.4368 43.9863 63.4369 43.9826 63.4406C43.9826 63.4406 43.9714 63.4369 43.9492 63.4294C43.9121 63.422 43.8787 63.4146 43.8452 63.396C43.8341 63.3923 43.8193 63.3886 43.8044 63.3812C43.6263 63.3181 43.3405 63.203 43.0658 63.0509C43.0436 63.0063 43.0287 62.9581 43.0176 62.9061C43.0398 62.7614 43.077 62.6092 43.1252 62.4607C43.3813 61.6776 43.9677 60.8685 44.6692 60.36C44.7583 60.2932 44.8548 60.2338 44.9476 60.1744C45.0144 60.1373 45.0775 60.1039 45.1443 60.0742C45.4041 60.2635 45.6194 60.4751 45.7381 60.5938H45.7418C45.7938 60.6532 45.8235 60.6866 45.8235 60.6866L45.8198 60.6829Z",
    fill: "url(#paint23_linear_188_8464)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0092 61.2207C46.0092 61.9296 45.4376 62.8315 44.7287 63.2435C44.0235 63.6517 43.4482 63.4068 43.4482 62.7016C43.4482 62.6236 43.4557 62.542 43.4705 62.4603C43.5744 61.7997 44.1015 61.0425 44.7287 60.6788C44.7807 60.6491 44.8326 60.6231 44.8809 60.6008C45.5193 60.3076 46.0092 60.5637 46.0092 61.2207Z",
    fill: "#D9DBDD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4009 61.6471C45.4009 61.9923 45.1225 62.434 44.7773 62.6307C44.4322 62.8274 44.1538 62.7123 44.1538 62.3671C44.1538 62.33 44.1538 62.2892 44.1649 62.2484C44.2169 61.9255 44.473 61.558 44.7773 61.3799C44.8033 61.365 44.8293 61.3539 44.8516 61.3428C45.1633 61.198 45.4009 61.3242 45.4009 61.6434V61.6471Z",
    fill: "url(#paint24_linear_188_8464)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M44.866 61.7312C44.866 61.8686 44.7546 62.0467 44.6173 62.1247C44.48 62.2026 44.3687 62.1581 44.3687 62.0207C44.3687 62.0059 44.3686 61.991 44.3724 61.9725C44.3946 61.8426 44.4948 61.6978 44.6173 61.6236C44.6285 61.6162 44.6359 61.6125 44.647 61.6088C44.7695 61.5531 44.866 61.6013 44.866 61.7312Z",
    fill: "#E3E5E6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4561 58.6724C43.4486 58.8431 42.2498 60.0939 41.1809 61.9904C40.717 62.8255 40.2716 63.7794 39.9635 64.8223L37.0537 62.9703C37.1502 61.9273 37.4954 60.9586 37.9408 60.1161C38.9466 58.175 40.4572 56.8945 40.5462 56.8203L43.4561 58.6724Z",
    fill: "#5CCCE6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4562 58.6724C43.4488 58.8431 42.25 60.0939 41.1811 61.9904L37.9409 60.1161C38.9467 58.175 40.4573 56.8945 40.5464 56.8203L43.4562 58.6724Z",
    fill: "#78D9FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3382 64.69L39.9634 64.8236C40.2826 61.3645 43.3297 58.7812 43.4596 58.6736L43.6341 58.9186C43.6044 58.9445 40.6352 61.4647 40.3382 64.69Z",
    fill: "#1C8EB0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M34.311 53.3984L38.9875 56.0559L38.4939 57.5962L33.8174 54.9387L34.311 53.3984Z",
    fill: "#4F4F4F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M34.329 52.6758L34.9451 55.7452V59.0485L35.9881 58.4435V60.277L34.9451 60.8782L34.6593 61.0452L33.7129 61.5908V53.0321L34.329 52.6758Z",
    fill: "#BDC1C4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6221 51.5014V52.2993C39.6221 52.8375 40.2938 53.2755 41.1252 53.2755C41.9566 53.2755 42.6284 52.8375 42.6284 52.2993V51.4531L39.6258 51.5014H39.6221Z",
    fill: "url(#paint25_linear_188_8464)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3379 50.7473V51.1036C38.3379 52.1057 39.585 52.9185 41.1252 52.9185C42.6655 52.9185 43.9126 52.1057 43.9126 51.1036V50.6582L38.3379 50.7473Z",
    fill: "url(#paint26_linear_188_8464)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1252 52.5634C42.6646 52.5634 43.9126 51.7509 43.9126 50.7485C43.9126 49.7461 42.6646 48.9336 41.1252 48.9336C39.5858 48.9336 38.3379 49.7461 38.3379 50.7485C38.3379 51.7509 39.5858 52.5634 41.1252 52.5634Z",
    fill: "#BBBBBB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9882 58.4441L34.9453 57.635V59.0491L35.9882 58.4441Z",
    fill: "#A6A9AB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2969 24.4921L94.5152 31.5476V29.8292L82.2969 22.7773V24.4921Z",
    fill: "#5A5C54"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5151 31.5454L94.8121 31.371V29.6562L94.5151 29.827V31.5454Z",
    fill: "#888888"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5938 22.6016L94.8121 29.6571L94.5152 29.8279L82.2969 22.776L82.5938 22.6016Z",
    fill: "#B2B2B2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2773 29.6594L94.4741 29.5443V28.301L94.2773 28.4123V29.6594Z",
    fill: "#949494"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2776 29.6567L94.0586 29.5305V28.2834L94.2776 28.4096V29.6567Z",
    fill: "#757575"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4743 28.3L94.2776 28.4114L94.0586 28.2852L94.2516 28.1701L94.4743 28.3Z",
    fill: "#C4C4C4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0083 27.7647L91.205 27.6496V26.4026L91.0083 26.5176V27.7647Z",
    fill: "#949494"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M91.008 27.7641L90.7891 27.6379V26.3908L91.008 26.517V27.7641Z",
    fill: "#757575"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2048 26.4018L91.008 26.5169L90.7891 26.3907L90.9858 26.2756L91.2048 26.4018Z",
    fill: "#C4C4C4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7417 25.8702L87.9384 25.7551V24.508L87.7417 24.6231V25.8702Z",
    fill: "#949494"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7414 25.8696L87.5225 25.7397V24.4963L87.7414 24.6225V25.8696Z",
    fill: "#757575"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9381 24.5092L87.7414 24.6243L87.5225 24.4981L87.7154 24.383L87.9381 24.5092Z",
    fill: "#C4C4C4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4717 23.9739L84.6684 23.8625V22.6154L84.4717 22.7305V23.9739Z",
    fill: "#949494"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4719 23.975L84.2529 23.8488V22.6018L84.4719 22.7317V23.975Z",
    fill: "#757575"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6686 22.6166L84.4719 22.7317L84.2529 22.6018L84.4496 22.4904L84.6686 22.6166Z",
    fill: "#C4C4C4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2032 26.8031L95.3166 26.1611L83.0983 19.1055L81.9849 19.7476L94.2032 26.8031Z",
    fill: "#B2B2B2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2031 28.7397L95.3166 28.0976V26.1602L94.2031 26.8022V28.7397Z",
    fill: "#888888"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9849 19.7461L94.2032 26.8017V28.7391L81.9849 21.6835V19.7461Z",
    fill: "#5A5C54"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7705 51.728L37.9888 58.7799V43.6629L25.7705 36.6073V51.728Z",
    fill: "#8A9399"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0983 21.7043L81.9849 22.3464V19.1359L83.0983 18.4901V21.7043Z",
    fill: "#AE59A1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0571 42.7136L80.43 21.7138V20.1698L44.0571 41.1658V42.7136Z",
    fill: "#AE59A1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5889 35.0583L80.7938 24.551L78.9455 21.5743L64.4854 29.9215L62.5889 35.0583Z",
    fill: "#001ACC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5371 34.7573C64.5371 36.5871 66.0217 37.2143 67.8515 36.1566C69.6813 35.0988 71.1659 32.7605 71.1659 30.9308C71.1659 29.101 69.6813 28.4737 67.8515 29.5315C66.0217 30.5893 64.5371 32.9276 64.5371 34.7573Z",
    fill: "#424852"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1494 30.3628C72.1494 32.1926 73.634 32.8198 75.4638 31.762C77.2936 30.7043 78.7782 28.366 78.7782 26.5362C78.7782 24.7065 77.2936 24.0792 75.4638 25.137C73.634 26.1948 72.1494 28.533 72.1494 30.3628Z",
    fill: "#424852"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4089 35.5964L62.8447 35.5445C63.1676 32.0668 66.2259 29.4725 66.3558 29.3611L66.3966 29.3314L76.7592 23.3559C76.8223 23.3373 78.3329 22.866 79.4501 23.5971C80.0736 24.0054 80.441 24.6957 80.5375 25.6496L79.9734 25.709C79.8917 24.9333 79.6134 24.384 79.1383 24.0722C78.318 23.534 77.1489 23.8347 76.9559 23.8903L66.701 29.8102C66.4523 30.0255 63.6947 32.4825 63.4052 35.5964H63.4089Z",
    fill: "#EAEF2F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M73.582 29.5352C73.582 30.5745 74.4245 30.9308 75.4601 30.3295C76.4993 29.7319 77.3381 28.4032 77.3381 27.364C77.3381 26.3248 76.4956 25.9685 75.4601 26.5697C74.4208 27.1673 73.582 28.496 73.582 29.5352Z",
    fill: "#ADD1B9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9736 33.9296C65.9736 34.9688 66.8161 35.3251 67.8517 34.7238C68.8909 34.1263 69.7297 32.7975 69.7297 31.7583C69.7297 30.7191 68.8872 30.3628 67.8517 30.9641C66.8124 31.5616 65.9736 32.8903 65.9736 33.9296Z",
    fill: "#ADD1B9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0988 25.1007L81.9854 25.7428V24.0578L83.0988 23.412V25.1007Z",
    fill: "#725986"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9165 24.1653L82.3857 24.4734V22.1165L82.9165 21.8085V24.1653Z",
    fill: "#725986"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2632 42.2664L62.1988 32.4902V31.6403L45.2632 41.4127V42.2664Z",
    fill: "#4CE786"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2632 44.4307L62.1988 34.6545V33.8009L45.2632 43.577V44.4307Z",
    fill: "#4CE786"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5532 36.6321L62.199 36.2572V30.7011L61.5532 31.0722V36.6321Z",
    fill: "#424852"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2002 46.9636L45.846 46.5925V40.205L45.2002 40.5761V46.9636Z",
    fill: "#424852"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8921 47.2157L46.1503 46.4882V46.1134L44.8921 46.8371V47.2157Z",
    fill: "#424852"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2754 49.7666L92.6482 28.7706V27.2266L56.2754 48.2226V49.7666Z",
    fill: "#3A3B36"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M72.25 40.6335L91.1639 28.6304L89.4195 27.6172L74.9594 35.9644L73.6307 39.5608L72.25 40.6335Z",
    fill: "#4A4D46"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M74.811 42.1132L91.9322 32.2258L88.8516 29.9023L74.9594 35.9632L72.25 40.6323L74.811 42.1132Z",
    fill: "#3A3B36"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5864 36.4159C82.5864 37.199 82.8574 37.7632 83.3102 38.0675C83.9189 38.4758 85.2216 39.181 85.2216 39.181C87.0514 38.1232 90.6478 34.4562 90.6478 32.6227C90.6478 31.8247 88.9331 31.2235 88.4655 30.9228C87.8568 30.5331 86.9363 30.5925 85.9008 31.1864C84.0711 32.2441 82.5864 34.5824 82.5864 36.4122V36.4159Z",
    fill: "url(#paint27_linear_188_8464)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3789 37.4625C84.3789 39.2923 85.8635 39.9195 87.6933 38.8618C89.5231 37.804 91.0077 35.4657 91.0077 33.6359C91.0077 31.8062 89.5231 31.1789 87.6933 32.2367C85.8635 33.2945 84.3789 35.6327 84.3789 37.4625Z",
    fill: "#424852"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3589 36.7202C85.3589 37.9339 86.3424 38.3496 87.5598 37.6481C88.7735 36.9466 89.7607 35.3952 89.7607 34.1778C89.7607 32.9605 88.7772 32.5485 87.5598 33.25C86.3424 33.9514 85.3589 35.5028 85.3589 36.7202Z",
    fill: "url(#paint28_linear_188_8464)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4961 36.8157C85.4961 38.0294 86.4796 38.4451 87.697 37.7436C88.9107 37.0421 89.8979 35.4907 89.8979 34.2733C89.8979 33.056 88.9144 32.644 87.697 33.3455C86.4834 34.0469 85.4961 35.5983 85.4961 36.8157Z",
    fill: "#D7D9DB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6678 34.4089C89.6678 35.5001 88.7845 36.8919 87.6933 37.5228C86.6058 38.1501 85.7188 37.7752 85.7188 36.6877C85.7188 36.5653 85.7299 36.4428 85.7522 36.3166C85.9155 35.2996 86.7246 34.1342 87.6933 33.5738C87.7712 33.5293 87.8529 33.4884 87.9271 33.4513C88.9069 32.9985 89.6678 33.3956 89.6678 34.4052V34.4089Z",
    fill: "url(#paint29_linear_188_8464)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7102 34.2967V34.3115C88.7102 35.1392 88.0421 36.1895 87.2145 36.6646C87.0623 36.7537 86.9176 36.8168 86.7765 36.8539C86.3163 36.9801 85.9489 36.8353 85.8041 36.4642C85.7818 36.4197 85.767 36.3714 85.7559 36.3157C85.7781 36.1673 85.8152 36.0188 85.8635 35.8666C86.1196 35.0798 86.7097 34.267 87.4149 33.7585C87.504 33.6917 87.6005 33.6286 87.6933 33.5729C87.7601 33.5358 87.8269 33.5024 87.89 33.4727C87.9048 33.4653 87.916 33.4579 87.9271 33.4542C88.3873 33.4356 88.6991 33.7362 88.7065 34.2967H88.7102Z",
    fill: "#E3E5E6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5731 34.089C88.5731 34.8981 87.5487 36.3715 86.7396 36.8503C86.7359 36.854 86.7322 36.854 86.7285 36.8578C86.7285 36.8578 86.7173 36.854 86.6951 36.8466C86.6579 36.8392 86.6245 36.8318 86.5911 36.8132C86.58 36.8095 86.5652 36.8058 86.5503 36.7984C86.3722 36.7353 86.0827 36.6202 85.808 36.468C85.7857 36.4235 85.7709 36.3753 85.7598 36.3196C85.782 36.1711 85.8191 36.0227 85.8674 35.8705C86.1235 35.0837 86.7136 34.2708 87.4188 33.7623C87.5079 33.6955 87.6044 33.6324 87.6972 33.5768C87.764 33.5397 87.8308 33.5063 87.8939 33.4766C88.1537 33.6658 88.3727 33.8811 88.4914 33.9962H88.4951C88.5471 34.0556 88.5768 34.089 88.5768 34.089H88.5731Z",
    fill: "url(#paint30_linear_188_8464)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7623 34.6302C88.7623 35.3428 88.187 36.2484 87.4744 36.6604C86.7655 37.0687 86.1865 36.8237 86.1865 36.1148C86.1865 36.0369 86.1939 35.9552 86.2088 35.8736C86.3164 35.2129 86.8435 34.4521 87.4744 34.0846C87.5264 34.0549 87.5783 34.0289 87.6266 34.0067C88.265 33.7097 88.7623 33.9696 88.7623 34.6302Z",
    fill: "#D9DBDD"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M88.15 35.0574C88.15 35.4026 87.8679 35.8479 87.5228 36.0484C87.1776 36.2488 86.8955 36.13 86.8955 35.7848C86.8955 35.7477 86.8955 35.7069 86.9066 35.6661C86.9586 35.3432 87.2147 34.972 87.5228 34.7939C87.5487 34.779 87.5747 34.7679 87.597 34.7568C87.9087 34.612 88.15 34.7382 88.15 35.0611V35.0574Z",
    fill: "url(#paint31_linear_188_8464)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6117 35.1391C87.6117 35.2764 87.5004 35.4546 87.3593 35.5362C87.222 35.6142 87.1069 35.5696 87.1069 35.4286C87.1069 35.4138 87.1069 35.3989 87.1106 35.3803C87.1329 35.2504 87.2331 35.102 87.3593 35.0315C87.3704 35.024 87.3779 35.0203 87.389 35.0166C87.5152 34.9572 87.6117 35.0092 87.6117 35.1391Z",
    fill: "#E3E5E6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M74.978 40.7674C74.978 41.5506 75.249 42.1147 75.7018 42.4191C76.3105 42.8273 77.6132 43.5325 77.6132 43.5325C79.443 42.4747 83.0394 38.8078 83.0394 36.9743C83.0394 36.1763 81.3247 35.575 80.8571 35.2744C80.2484 34.8847 79.3279 34.9441 78.2924 35.5379C76.4627 36.5957 74.978 38.934 74.978 40.7637V40.7674Z",
    fill: "url(#paint32_linear_188_8464)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7705 41.8142C76.7705 43.644 78.2551 44.2712 80.0849 43.2134C81.9147 42.1556 83.3993 39.8174 83.3993 37.9876C83.3993 36.1578 81.9147 35.5306 80.0849 36.5884C78.2551 37.6462 76.7705 39.9844 76.7705 41.8142Z",
    fill: "#424852"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7505 41.0698C77.7505 42.2835 78.734 42.6992 79.9514 41.9977C81.1651 41.2962 82.1523 39.7448 82.1523 38.5275C82.1523 37.3101 81.1688 36.8981 79.9514 37.5996C78.7377 38.3011 77.7505 39.8525 77.7505 41.0698Z",
    fill: "url(#paint33_linear_188_8464)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8843 41.1676C77.8843 42.3813 78.8678 42.797 80.0852 42.0955C81.2989 41.394 82.2861 39.8426 82.2861 38.6252C82.2861 37.4078 81.3026 36.9959 80.0852 37.6973C78.8715 38.3988 77.8843 39.9502 77.8843 41.1676Z",
    fill: "#D7D9DB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M82.056 38.7585C82.056 39.8497 81.1726 41.2415 80.0814 41.8724C78.994 42.4997 78.1069 42.1248 78.1069 41.0374C78.1069 40.9149 78.1181 40.7924 78.1403 40.6662C78.3036 39.6493 79.1127 38.4838 80.0814 37.9234C80.1594 37.8789 80.241 37.838 80.3153 37.8009C81.2951 37.3481 82.056 37.7452 82.056 38.7548V38.7585Z",
    fill: "url(#paint34_linear_188_8464)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0984 38.648V38.6629C81.0984 39.4905 80.4303 40.5409 79.6027 41.016C79.4505 41.105 79.3057 41.1681 79.1647 41.2052C78.7045 41.3314 78.337 41.1867 78.1923 40.8155C78.17 40.771 78.1552 40.7227 78.144 40.6671C78.1663 40.5186 78.2034 40.3702 78.2517 40.218C78.5078 39.4311 79.0979 38.6183 79.8031 38.1098C79.8922 38.043 79.9887 37.9799 80.0814 37.9243C80.1482 37.8872 80.2151 37.8537 80.2782 37.8241C80.293 37.8166 80.3041 37.8092 80.3153 37.8055C80.7755 37.7869 81.0873 38.0876 81.0947 38.648H81.0984Z",
    fill: "#E3E5E6"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9647 38.4405C80.9647 39.2496 79.9403 40.7231 79.1312 41.2019C79.1275 41.2056 79.1238 41.2056 79.1201 41.2093C79.1201 41.2093 79.1089 41.2056 79.0867 41.1982C79.0495 41.1908 79.0161 41.1833 78.9827 41.1648C78.9716 41.1611 78.9568 41.1574 78.9419 41.1499C78.7638 41.0868 78.4743 40.9718 78.1996 40.8196C78.1773 40.7751 78.1625 40.7268 78.1514 40.6711C78.1736 40.5227 78.2107 40.3742 78.259 40.2221C78.5151 39.4352 79.1052 38.6224 79.8104 38.1139C79.8995 38.0471 79.996 37.984 80.0888 37.9283C80.1556 37.8912 80.2224 37.8578 80.2855 37.8281C80.5453 38.0174 80.7643 38.2327 80.883 38.3477H80.8868C80.9387 38.4071 80.9684 38.4405 80.9684 38.4405H80.9647Z",
    fill: "url(#paint35_linear_188_8464)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1505 38.9818C81.1505 39.6944 80.5752 40.6 79.8626 41.012C79.1537 41.4202 78.5747 41.1753 78.5747 40.4664C78.5747 40.3884 78.5821 40.3068 78.597 40.2251C78.7046 39.5645 79.2317 38.8036 79.8626 38.4362C79.9146 38.4065 79.9665 38.3805 80.0148 38.3582C80.6532 38.0613 81.1505 38.3211 81.1505 38.9818Z",
    fill: "#D9DBDD"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5416 39.4109C80.5416 39.7561 80.2595 40.2015 79.9144 40.4019C79.5692 40.6023 79.2871 40.4835 79.2871 40.1384C79.2871 40.1013 79.2871 40.0604 79.2982 40.0196C79.3502 39.6967 79.6063 39.3255 79.9144 39.1474C79.9403 39.1325 79.9663 39.1214 79.9886 39.1103C80.3003 38.9655 80.5416 39.0917 80.5416 39.4146V39.4109Z",
    fill: "url(#paint36_linear_188_8464)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0038 39.4907C80.0038 39.628 79.8924 39.8061 79.7514 39.8878C79.6141 39.9657 79.499 39.9212 79.499 39.7802C79.499 39.7653 79.499 39.7505 79.5027 39.7319C79.525 39.602 79.6252 39.4535 79.7514 39.383C79.7625 39.3756 79.7699 39.3719 79.7811 39.3682C79.9073 39.3088 80.0038 39.3608 80.0038 39.4907Z",
    fill: "#E3E5E6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M74.811 42.1148L76.9339 36.8742L74.9594 35.9648L72.25 40.6339L74.811 42.1148Z",
    fill: "#21221C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0631 42.6001L72.3574 41.0895C72.6803 37.6118 75.7386 35.0175 75.8685 34.9061L75.9093 34.8764L86.2719 28.9009C86.335 28.8824 87.8456 28.411 88.9628 29.1422C89.2634 29.3389 91.4866 30.3224 91.6684 30.6528C91.8614 31.0016 90.002 30.7047 90.0539 31.1946L89.4898 31.254C89.4081 30.4783 89.3636 30.6602 89.0704 30.7084C88.1017 30.8643 88.3392 31.2058 88.1462 31.2577L78.7746 36.7767C78.526 36.992 75.3489 39.4861 75.0631 42.5964V42.6001Z",
    fill: "#B3B3B3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4895 31.256L92.1952 32.7666C92.1952 32.7666 92.4921 31.9315 92.1952 31.6791C91.8982 31.4267 91.104 30.3801 90.358 30.4357C89.612 30.4914 89.3818 30.7327 89.3818 30.7327L89.4895 31.256Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6271 42.6532L75.063 42.6012C75.3859 39.1236 78.4442 36.5292 78.5741 36.4179L78.6149 36.3882L88.9774 30.4126C89.0405 30.3941 90.5511 29.9227 91.6683 30.6539C92.2918 31.0622 92.6593 31.7525 92.7558 32.7064L92.1916 32.7657C92.11 31.99 91.8316 31.4407 91.3565 31.129C90.5363 30.5908 89.3671 30.8914 89.1741 30.9471L78.9193 36.867C78.6706 37.0822 75.9129 39.5392 75.6234 42.6532H75.6271Z",
    fill: "#808794"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4173 43.3139L73.7715 43.6851V38.129L74.4173 37.7578V43.3139Z",
    fill: "#888888"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7713 43.6198L73.3223 43.4194V37.8633L73.7713 38.1268V43.6198Z",
    fill: "#5A5C54"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2699 48.7001V49.4387L73.6785 39.566L73.3296 39.3359L57.2588 48.6147C57.2588 48.6444 57.2662 48.6704 57.2662 48.7038L57.2699 48.7001Z",
    fill: "#B2B2B2"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M57.27 51.6004L73.6786 41.724L73.3334 41.4939L57.27 50.769V51.6004Z",
    fill: "#B2B2B2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M57.27 49.0343V49.8879L73.6786 40.4124V39.5625L57.27 49.0343Z",
    fill: "#888888"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3727 53.1737L57.1145 53.9012L56.2905 53.415L57.5487 52.6875L58.3727 53.1737Z",
    fill: "#B2B2B2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2257 53.6001L56.7803 53.3328V46.9453L57.2257 47.2125V53.6001Z",
    fill: "#5A5C54"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8714 53.2289L57.2256 53.6V47.2125L57.8714 46.8377V53.2289Z",
    fill: "#888888"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3724 53.5504L57.1143 54.2779V53.8993L58.3724 53.1719V53.5504Z",
    fill: "#888888"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M56.29 53.4158L57.114 53.902V54.2806L56.29 53.7907V53.4158Z",
    fill: "#5A5C54"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M57.27 51.1981V52.0481L73.6786 42.5763V41.7227L57.27 51.1981Z",
    fill: "#888888"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9888 58.7778L94.9753 25.8826V10.7656L37.9888 43.6608V58.7778Z",
    fill: "#A8B3BA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2219 12.0742V23.5428L65.6692 40.0256L63.9471 41.0203L38.7422 55.5657V44.0972L63.5314 29.7893L63.9471 29.5517L63.9656 29.5406L65.6692 28.557L94.2219 12.0742Z",
    fill: "#9FA9B0"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8433 12.2932V23.2718L38.7422 55.0795V55.5694L94.2219 23.5428V12.0742L93.8433 12.2932Z",
    fill: "#EDF2F6"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2218 23.5428L93.8433 23.2718V12.2932L94.2218 12.0742V23.5428Z",
    fill: "#8A9399"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9888 58.7783L95.417 24.1053L94.9753 23.8789L37.9888 56.774V58.7783Z",
    fill: "#B2B2B2"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4307 59.0085L95.4172 26.1097V24.1055L38.4307 57.0043V59.0085Z",
    fill: "#888888"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0059 58.1891L94.9421 25.9027V24.8672L39.0059 57.1573V58.1891Z",
    fill: "#DADED5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9754 10.7665L82.7571 3.71094L25.7705 36.6061L37.9888 43.6616L94.9754 10.7665Z",
    fill: "#EDF2F6"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4304 57.0036L37.9888 56.7734V58.7777L38.4304 59.0078V57.0036Z",
    fill: "#2E2E2E"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0062 57.0414L40.1377 57.5498V56.5106L41.0062 56.0059V57.0414Z",
    fill: "#0020F5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2723 55.1547L43.4038 55.6594V54.6239L44.2723 54.1191V55.1547Z",
    fill: "#0020F5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5386 53.2697L46.6738 53.7745V52.7389L47.5386 52.2305V53.2697Z",
    fill: "#0020F5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8084 51.3812L49.9399 51.8897V50.8505L50.8084 50.3457V51.3812Z",
    fill: "#0020F5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0746 49.4945L53.2061 49.9993V48.9638L54.0746 48.459V49.4945Z",
    fill: "#0020F5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3404 47.6115L56.4756 48.1163V47.0807L57.3404 46.5723V47.6115Z",
    fill: "#0020F5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6102 45.7211L59.7417 46.2295V45.1903L60.6102 44.6855V45.7211Z",
    fill: "#0020F5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8763 43.8361L63.0078 44.3408V43.3053L63.8763 42.8006V43.8361Z",
    fill: "#0020F5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1426 41.9476L66.2778 42.4561V41.4206L67.1426 40.9121V41.9476Z",
    fill: "#0020F5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4087 40.0592L69.5439 40.5639V39.5284L70.4087 39.0237V40.0592Z",
    fill: "#0020F5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6785 38.1764L72.8101 38.6811V37.6456L73.6785 37.1408V38.1764Z",
    fill: "#0020F5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9447 36.2875L76.0762 36.7959V35.7567L76.9447 35.252V36.2875Z",
    fill: "#0020F5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M80.211 34.4007L79.3462 34.9055V33.87L80.211 33.3652V34.4007Z",
    fill: "#0020F5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4808 32.5158L82.6123 33.0205V31.985L83.4808 31.4766V32.5158Z",
    fill: "#0020F5"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7469 30.6254L85.8784 31.1338V30.0946L86.7469 29.5898V30.6254Z",
    fill: "#0020F5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0127 28.7406L89.1479 29.2454V28.2098L90.0127 27.7051V28.7406Z",
    fill: "#0020F5"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M93.283 26.8554L92.4146 27.3602V26.3247L93.283 25.8162V26.8554Z",
    fill: "#0020F5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5514 76.2639C20.4029 76.2639 20.2545 76.2231 20.1171 76.1452L12.2005 71.5763C11.5213 71.1829 11.0981 70.4517 11.0981 69.6649V68.1172H11.473V69.6649C11.473 70.3181 11.8219 70.9231 12.3897 71.2497L20.3064 75.8186C20.4586 75.9077 20.6442 75.9077 20.7963 75.8186C20.9485 75.7295 21.0413 75.5699 21.0413 75.3955V73.3133H21.4162V75.3955C21.4162 75.7072 21.2528 75.9893 20.9819 76.1452C20.8446 76.2231 20.6961 76.2639 20.5477 76.2639H20.5514Z",
    fill: "#949799"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9672 64.0508V66.3593L23.3799 72.9658V70.661L34.9672 64.0508Z",
    fill: "#222222"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6707 72.935C22.6707 73.7144 22.9416 74.2749 23.3907 74.5792C23.9957 74.9838 25.291 75.689 25.291 75.689C27.1134 74.6386 30.6876 70.9865 30.6876 69.1641C30.6876 68.3736 28.984 67.7723 28.5163 67.4717C27.9114 67.082 26.9946 67.1413 25.9628 67.7352C24.1405 68.7855 22.667 71.1164 22.667 72.935H22.6707Z",
    fill: "url(#paint37_linear_188_8464)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4521 73.9747C24.4521 75.7971 25.9293 76.4206 27.748 75.3703C29.5703 74.3199 31.0438 71.9891 31.0438 70.1704C31.0438 68.3518 29.5666 67.7245 27.748 68.7749C25.9256 69.8252 24.4521 72.1561 24.4521 73.9747Z",
    fill: "#424852"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4282 73.2343C25.4282 74.4442 26.4081 74.8562 27.618 74.1585C28.828 73.4607 29.8078 71.9167 29.8078 70.7067C29.8078 69.4968 28.828 69.0848 27.618 69.7826C26.4081 70.4803 25.4282 72.0243 25.4282 73.2343Z",
    fill: "url(#paint38_linear_188_8464)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M25.562 73.3359C25.562 74.5458 26.5418 74.9578 27.7518 74.26C28.9618 73.5623 29.9416 72.0183 29.9416 70.8083C29.9416 69.5984 28.9618 69.1864 27.7518 69.8841C26.5418 70.5819 25.562 72.1259 25.562 73.3359Z",
    fill: "#D7D9DB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7154 70.939C29.7154 72.0227 28.8357 73.4108 27.752 74.0381C26.6719 74.6616 25.7886 74.2905 25.7886 73.2067C25.7886 73.0879 25.7997 72.9618 25.822 72.8393C25.9853 71.8297 26.7907 70.668 27.752 70.1076C27.8299 70.0631 27.9078 70.0222 27.9858 69.9888C28.9619 69.5397 29.7154 69.9332 29.7154 70.939Z",
    fill: "url(#paint39_linear_188_8464)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7613 70.8259V70.8408C28.7613 71.6647 28.0969 72.7114 27.273 73.1827C27.1245 73.2718 26.9761 73.3312 26.8387 73.372C26.3822 73.4945 26.0148 73.3535 25.87 72.986C25.8478 72.9415 25.8329 72.8932 25.8218 72.8413C25.844 72.6965 25.8812 72.5443 25.9294 72.3959C26.1855 71.6128 26.7719 70.8037 27.4734 70.2952C27.5625 70.2284 27.659 70.169 27.7518 70.1096C27.8186 70.0725 27.8817 70.0391 27.9485 70.0094C27.9633 70.002 27.9745 69.9945 27.9856 69.9908C28.4421 69.9723 28.7539 70.2729 28.7613 70.8296V70.8259Z",
    fill: "#E3E5E6"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28.624 70.6204C28.624 71.4258 27.607 72.8918 26.7979 73.3706C26.7942 73.3743 26.7905 73.3744 26.7868 73.3781C26.7868 73.3781 26.7756 73.3743 26.7534 73.3669C26.7163 73.3595 26.6829 73.3521 26.6494 73.3335C26.6383 73.3298 26.6235 73.3261 26.6086 73.3187C26.4305 73.2556 26.1447 73.1405 25.87 72.9884C25.8478 72.9438 25.8329 72.8956 25.8218 72.8436C25.844 72.6989 25.8812 72.5467 25.9294 72.3982C26.1855 71.6151 26.7719 70.806 27.4734 70.2975C27.5625 70.2307 27.659 70.1713 27.7518 70.1119C27.8186 70.0748 27.8817 70.0414 27.9485 70.0117C28.2083 70.201 28.4235 70.4126 28.5423 70.5313H28.546C28.598 70.5907 28.6277 70.6241 28.6277 70.6241L28.624 70.6204Z",
    fill: "url(#paint40_linear_188_8464)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8129 71.1621C28.8129 71.871 28.2413 72.7729 27.5324 73.1848C26.8272 73.5931 26.252 73.3482 26.252 72.643C26.252 72.565 26.2594 72.4834 26.2742 72.4017C26.3781 71.7411 26.9052 70.9839 27.5324 70.6202C27.5844 70.5905 27.6363 70.5645 27.6846 70.5422C28.323 70.249 28.8129 70.5051 28.8129 71.1621Z",
    fill: "#D9DBDD"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2046 71.5827C28.2046 71.9278 27.9262 72.3695 27.5811 72.5662C27.2359 72.7629 26.9575 72.6479 26.9575 72.3027C26.9575 72.2656 26.9575 72.2248 26.9687 72.1839C27.0206 71.861 27.2767 71.4936 27.5811 71.3155C27.607 71.3006 27.633 71.2895 27.6553 71.2783C27.9671 71.1336 28.2046 71.2598 28.2046 71.579V71.5827Z",
    fill: "url(#paint41_linear_188_8464)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6702 71.6648C27.6702 71.8022 27.5588 71.9803 27.4215 72.0583C27.2842 72.1362 27.1729 72.0916 27.1729 71.9543C27.1729 71.9395 27.1729 71.9246 27.1766 71.9061C27.1988 71.7762 27.299 71.6314 27.4215 71.5572C27.4327 71.5498 27.4401 71.5461 27.4512 71.5423C27.5737 71.4867 27.6702 71.5349 27.6702 71.6648Z",
    fill: "#E3E5E6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6732 69.7343L37.6132 66.8134C38.2702 66.4348 38.3295 65.3065 37.7468 64.297C37.1641 63.2874 36.1583 62.7753 35.5014 63.1538L30.502 66.1082L32.6732 69.7343Z",
    fill: "url(#paint42_linear_188_8464)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5613 66.0744C31.2183 65.6958 32.2241 66.2043 32.8068 67.2175C33.3895 68.2271 33.3301 69.3554 32.6732 69.7339C32.0163 70.1125 31.0104 69.604 30.4277 68.5908C29.845 67.5775 29.9044 66.453 30.5613 66.0744Z",
    fill: "#8D9296"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5356 66.5733C31.0626 66.269 31.868 66.6772 32.3356 67.4863C32.8033 68.2955 32.755 69.1974 32.228 69.5017C31.701 69.806 30.8956 69.3978 30.4279 68.5887C29.9603 67.7795 30.0085 66.8776 30.5356 66.5733Z",
    fill: "#80898A"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2398 49.112L28.6725 56.8468L17.5825 58.9624V49.5574C17.5825 48.7891 18.284 47.2118 18.7479 46.5994C20.4886 44.3056 21.3089 43.5411 23.109 42.6837L34.2361 49.112H34.2398Z",
    fill: "#70CAED"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M25.989 55.169C25.989 54.4008 26.7053 52.5487 27.121 51.9029C28.717 49.4311 30.042 48.6331 31.8198 47.7831V47.3637L24.857 43.7636C23.0532 44.6209 21.6391 46.3245 20.689 48.7518C20.4069 49.4682 19.9096 50.7969 19.9096 51.5689L19.3306 60.046L26.3231 58.7098L25.9853 55.1728L25.989 55.169Z",
    fill: "#1C8EB0"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M25.989 54.7531C25.989 53.9849 26.7053 52.1328 27.121 51.487C28.717 49.0151 30.042 48.2172 31.8198 47.3672L24.857 43.3477C23.0532 44.205 21.6391 45.9086 20.689 48.3359C20.4069 49.0522 19.9096 50.381 19.9096 51.153L19.3306 59.6301L26.3231 58.2939L25.9853 54.7569L25.989 54.7531Z",
    fill: "#78D9FF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2398 64.3249L28.7134 67.5094V57.2842C28.7134 56.4491 28.8693 55.4989 29.1885 54.7269C29.8194 53.2015 32.488 49.6013 34.2398 49.1151V64.3249Z",
    fill: "#1C8EB0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9844 61.6487C30.7469 61.6487 30.5576 61.4557 30.5576 61.2219V56.7347C30.5576 56.512 30.6764 56.3004 30.8731 56.1891L31.7564 55.6806C31.8232 55.6435 31.8938 55.6212 31.968 55.6212C32.2018 55.6212 32.3948 55.8142 32.3948 56.048V60.5353C32.3948 60.758 32.276 60.9695 32.0793 61.0808L31.196 61.5893C31.1292 61.6264 31.0587 61.6487 30.9844 61.6487Z",
    fill: "#006B96"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0349 60.9499L31.1515 61.4583C30.966 61.566 30.7358 61.4324 30.7358 61.2171V56.7299C30.7358 56.5592 30.8286 56.3995 30.9771 56.3142L31.8604 55.8057C32.046 55.6981 32.2761 55.8317 32.2761 56.047V60.5342C32.2761 60.7049 32.1833 60.8645 32.0349 60.9499Z",
    fill: "#1C8EB0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2193 65.314L17.6009 62.1258V50.4493L11.9706 54.4541L12.2823 55.4153L11.5215 59.832L12.2193 65.314Z",
    fill: "#0020F5"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3711 59.1355L16.1086 56.9754V53.6759L12.9167 55.5168L12.3711 59.1355Z",
    fill: "#74C7AC"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0041 61.5427L13.1616 62.1106L12.4639 59.9653L14.0041 59.0782V61.5427Z",
    fill: "#74C7AC"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9824 67.2404C13.9824 69.0628 15.4596 69.6863 17.2782 68.6359C19.1006 67.5856 19.88 65.5777 19.88 63.7553C19.88 61.933 18.4028 61.3094 16.5842 62.3598C14.7618 63.4101 13.9824 65.4181 13.9824 67.2404Z",
    fill: "#424852"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2998 66.4795C15.2998 67.5744 16.1869 67.9493 17.278 67.3146C18.3729 66.6836 18.5622 65.6073 18.5622 64.5124C18.5622 63.4175 17.6752 63.0427 16.584 63.6736C15.4891 64.3046 15.2998 65.3809 15.2998 66.4758V66.4795Z",
    fill: "#ADD1B9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6635 62.1282L19.8798 59.6935V60.1797L15.6635 62.6144C13.5813 63.817 13.6853 65.8323 13.6853 65.8323L13.5516 66.6154L13.0654 66.8938L13.2028 66.0661C13.6518 63.8281 14.7653 62.5847 15.6635 62.1245V62.1282Z",
    fill: "#74C7AC"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7281 56.877V67.9224L26.7907 69.0396C26.0113 69.4887 25.4397 70.1011 25.0277 70.6875L24.2706 71.1255L22.6523 72.0608V66.2597L23.4095 61.8392L23.094 60.878L24.9795 57.8791L28.7281 56.877Z",
    fill: "#1C8EB0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1143 74.3339L23.9106 73.2168C23.9106 73.2168 23.7399 70.5593 27.2361 68.4512L22.1143 70.2364V74.3302V74.3339Z",
    fill: "#1C8EB0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1143 73.162L22.7118 73.4812V66.125L22.1143 66.6966V73.162Z",
    fill: "#1C8EB0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0069 66.1212L31.6156 66.4738C31.6156 66.4738 26.2265 69.9292 25.8182 70.5156C25.139 71.4955 24.1072 74.0007 24.1072 74.0007L23.4985 73.6481L23.6359 72.8168C23.7583 72.2006 23.9847 71.6328 24.2705 71.128C25.0091 69.803 26.1411 68.89 26.7906 68.556L28.7281 67.4351L31.0069 66.1212Z",
    fill: "#878787"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6195 66.4728V66.959L29.3407 68.2728L27.4032 69.39C26.6238 69.8391 26.0523 70.4515 25.6403 71.0379C24.9611 72.0178 24.7272 72.9308 24.7272 72.9308L24.5936 73.7139L24.1074 73.996L24.2447 73.1646C24.3672 72.5485 24.5936 71.9806 24.8794 71.4759C25.618 70.1509 26.75 69.2378 27.3995 68.9038L29.3369 67.7866L31.6158 66.4728H31.6195Z",
    fill: "#4F4F4F"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2823 55.4141L23.4095 61.8424L22.6523 66.2591L11.5215 59.8308L12.2823 55.4141Z",
    fill: "#2EA8C6"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2825 55.4124L11.9707 54.4512L23.0978 60.8795L23.4096 61.8408L12.2825 55.4124Z",
    fill: "#176BA6"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6009 50.4453C17.6009 50.4453 13.2324 52.1155 11.9668 54.45C11.9668 54.45 14.9137 57.0852 23.0939 60.8784C23.0939 60.8784 24.2259 58.8964 28.728 56.8737C28.728 56.8737 20.4959 53.1399 17.6009 50.4453Z",
    fill: "#4ECEFF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9868 60.2695L22.1139 66.6979V73.3823L14.7911 69.886L10.9868 66.8983V60.2695Z",
    fill: "#006A92"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3363 69.1511L18.7551 72.2651C18.9258 72.3653 19.1411 72.2391 19.1411 72.0424V67.4698C19.1411 67.2434 19.0186 67.0318 18.8219 66.9205C18.8219 66.9205 14.7652 65.1613 13.4031 63.8065C13.2621 63.6655 13.0171 63.8325 13.0171 64.0292V68.6018C13.0171 68.8282 13.1396 69.0398 13.3363 69.1511Z",
    fill: "#7895A4"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8814 72.2064L13.4626 69.0924C13.2659 68.9811 13.1434 68.7695 13.1434 68.5431V63.9706C13.1434 63.8889 13.1805 63.8221 13.2325 63.7776C13.1137 63.7961 13.0098 63.8926 13.0098 64.0299V68.6025C13.0098 68.8289 13.1322 69.0405 13.329 69.1518L18.7478 72.2658C18.848 72.3252 18.963 72.3029 19.041 72.2361C18.989 72.2435 18.9296 72.2361 18.8777 72.2064H18.8814Z",
    fill: "#CEDBDB"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 67.4789V72.0589C19.1412 72.2593 18.9259 72.3818 18.7589 72.2853L13.329 69.1602C13.1322 69.0488 13.0098 68.8373 13.0098 68.6109V64.0309C13.0098 64.0049 13.0135 63.9789 13.0246 63.9529C13.0395 63.9047 13.0654 63.8639 13.1026 63.8305C13.1434 63.7933 13.1916 63.7674 13.2399 63.7599C13.2956 63.7525 13.3475 63.7636 13.3921 63.8082C13.4403 63.8564 13.496 63.9084 13.5516 63.9566C13.8745 64.2461 14.2977 64.5468 14.7727 64.8437C14.7876 64.8511 14.7987 64.8585 14.8136 64.8697C15.5262 65.3113 16.3353 65.7419 17.0368 66.0945C17.0553 66.1019 17.0739 66.113 17.0924 66.1242C18.0611 66.5992 18.8183 66.9333 18.8183 66.9333C18.8925 66.9778 18.9556 67.0335 19.0076 67.1077C19.0558 67.1671 19.0929 67.2413 19.1115 67.3193C19.1263 67.3712 19.1338 67.4269 19.1338 67.4863L19.1412 67.4789Z",
    fill: "#454736"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8888 72.2249L13.4626 69.1035C13.2659 68.9885 13.1434 68.7807 13.1434 68.5542V63.9742C13.1434 63.8926 13.1805 63.8258 13.2325 63.7812C13.1137 63.7998 13.0098 63.8963 13.0098 64.0336V68.6136C13.0098 68.84 13.1322 69.0516 13.329 69.1629L18.7552 72.2843C18.8554 72.3437 18.9705 72.3214 19.0484 72.2546C18.9964 72.262 18.937 72.2546 18.8851 72.2249H18.8888Z",
    fill: "#CEDBDB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 70.8402V71.1742C17.638 70.4542 15.1736 69.1997 13.0098 67.7967V67.459C15.1736 68.8582 17.638 70.1127 19.1412 70.8402Z",
    fill: "#73818E"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 70.2074V70.5451C17.638 69.8214 15.1736 68.5669 13.0098 67.1639V66.8262C15.1736 68.2254 17.638 69.4799 19.1412 70.2074Z",
    fill: "#73818E"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 69.5706V69.9084C17.638 69.1884 15.1736 67.9339 13.0098 66.5272V66.1895C15.1736 67.5924 17.638 68.8469 19.1412 69.5706Z",
    fill: "#73818E"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 68.9156V69.2533C17.638 68.5333 15.1736 67.2788 13.0098 65.8721V65.5566C15.1736 66.9522 17.638 68.1955 19.1412 68.9156Z",
    fill: "#73818E"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 71.0169V71.3547C17.4858 70.5382 15.0474 69.2651 13.0098 67.9549V67.6172C15.0474 68.9274 17.4858 70.2004 19.1412 71.0169Z",
    fill: "#91ACBA"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 70.3812V70.7189C17.638 69.9952 15.1736 68.7407 13.0098 67.3377V67C15.1736 68.3992 17.638 69.6537 19.1412 70.3812Z",
    fill: "#91ACBA"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 69.7474V70.0852C17.4858 69.2686 15.0474 67.9956 13.0098 66.6854V66.3477C15.0474 67.6578 17.4858 68.9309 19.1412 69.7474Z",
    fill: "#91ACBA"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 69.0882V69.426C17.638 68.7059 15.1736 67.4514 13.0098 66.0448V65.707C15.1736 67.11 17.638 68.3645 19.1412 69.0882Z",
    fill: "#91ACBA"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 68.256V68.5937C17.638 67.8737 15.1736 66.6192 13.0098 65.2125V64.8748C15.1736 66.2777 17.638 67.5322 19.1412 68.256Z",
    fill: "#73818E"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 67.6251V67.9629C17.638 67.2391 15.1736 65.9846 13.0098 64.578V64.2402C15.1736 65.6432 17.638 66.8977 19.1412 67.6251Z",
    fill: "#73818E"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1187 67.3132C17.6156 66.5932 15.1734 65.3461 13.0244 63.9506C13.0393 63.9023 13.0652 63.8615 13.1024 63.8281C13.1432 63.791 13.1914 63.765 13.2397 63.7576C13.3436 63.8244 13.4512 63.8912 13.5552 63.958C13.8781 64.2475 14.3012 64.5481 14.7762 64.8451C14.7911 64.8525 14.8022 64.8599 14.8171 64.8711C15.5668 65.3016 16.324 65.7173 17.0403 66.0958C17.0588 66.1033 17.0774 66.1144 17.0959 66.1255C18.0647 66.6006 18.8218 66.9347 18.8218 66.9347C18.896 66.9792 18.9591 67.0349 19.0111 67.1091C19.0593 67.1685 19.0965 67.2427 19.115 67.3206L19.1187 67.3132Z",
    fill: "#73818E"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 68.4329V68.7707C17.4858 67.9541 15.0474 66.6811 13.0098 65.3709V65.0332C15.0474 66.3434 17.4858 67.6164 19.1412 68.4329Z",
    fill: "#91ACBA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 67.7951V68.1328C17.638 67.4091 15.1736 66.1546 13.0098 64.7479V64.4102C15.1736 65.8131 17.638 67.0676 19.1412 67.7951Z",
    fill: "#91ACBA"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 67.4746V67.4931C17.4858 66.6803 15.0474 65.4073 13.0098 64.0971V64.0266C13.0098 64.0006 13.0135 63.9746 13.0246 63.9486C13.0395 63.9004 13.0654 63.8596 13.1026 63.8262C13.6444 64.1713 14.2049 64.5091 14.7764 64.8394C14.7913 64.8468 14.8024 64.8543 14.8173 64.8654C15.567 65.2959 16.3241 65.7116 17.0405 66.0902C17.059 66.0976 17.0776 66.1087 17.0961 66.1199C17.7865 66.4836 18.4397 66.8139 19.0113 67.0997C19.0595 67.1591 19.0966 67.2333 19.1152 67.3113C19.1301 67.3632 19.1375 67.4189 19.1375 67.4783L19.1412 67.4746Z",
    fill: "#91ACBA"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6521 66.2604L22.1139 66.6946C22.1139 66.6946 15.2588 64.2153 10.9868 60.2663L11.525 59.832L22.6521 66.2604Z",
    fill: "#35B7DE"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0849 65.0203C23.9476 65.0203 23.814 64.9572 23.7286 64.8495C23.6432 64.7419 23.6098 64.6046 23.6395 64.4672L24.1183 61.2828C24.2148 60.83 24.4895 60.4403 24.8718 60.1953L26.4974 59.1598C26.5828 59.1078 26.6793 59.0781 26.7758 59.0781C27.0615 59.0781 27.2954 59.312 27.2954 59.5977V62.463C27.2954 62.9381 27.0393 63.3835 26.6273 63.621L24.3113 64.9572C24.2408 64.998 24.1629 65.0203 24.0849 65.0203Z",
    fill: "#4F4F4F"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2369 64.8296L26.5529 63.4935C26.9204 63.2819 27.1468 62.8885 27.1468 62.4654V59.6001C27.1468 59.3106 26.8239 59.1325 26.5789 59.2884L24.9533 60.3239C24.6044 60.5466 24.3557 60.9029 24.2666 61.3074L23.7841 64.4993C23.7285 64.7591 24.0031 64.9595 24.2332 64.8296H24.2369Z",
    fill: "#6BA9B0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M24.211 69.2848C23.9735 69.2848 23.7842 69.0918 23.7842 68.8579V66.6681C23.7842 66.4455 23.9067 66.2339 24.0997 66.1226L24.983 65.6141C25.0498 65.577 25.1203 65.5547 25.1946 65.5547C25.4284 65.5547 25.6214 65.7477 25.6214 65.9815V68.1713C25.6214 68.394 25.5026 68.6056 25.3059 68.7169L24.4226 69.2254C24.3558 69.2625 24.2852 69.2848 24.211 69.2848Z",
    fill: "#4F4F4F"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2316 68.5858L24.3483 69.0943C24.1627 69.2019 23.9326 69.0683 23.9326 68.853V66.6632C23.9326 66.4925 24.0254 66.3329 24.1739 66.2476L25.0572 65.7391C25.2428 65.6314 25.4729 65.7651 25.4729 65.9803V68.1701C25.4729 68.3408 25.3801 68.5004 25.2316 68.5858Z",
    fill: "#4E98A1"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2396 63.0761L29.0435 66.1381V67.1476L29.2847 67.2961L34.4808 63.2282L34.2396 63.0761Z",
    fill: "#DDE2E6"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4808 63.2304L29.2847 66.2886V67.2982L34.4808 64.2399V63.2304Z",
    fill: "#A6A9AB"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4601 64.2523V64.4119C33.4601 64.4824 33.4193 64.5492 33.3562 64.5863L32.6733 64.9835C32.6176 65.0169 32.5508 64.976 32.5508 64.9129V64.8684L33.1224 64.5344C33.1854 64.4972 33.2263 64.4305 33.2263 64.3599V64.2449L33.3376 64.1818C33.3933 64.1484 33.4601 64.1892 33.4601 64.2523Z",
    fill: "#80898A"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2263 64.2499V64.3649C33.2263 64.4355 33.1854 64.5023 33.1224 64.5394L32.5508 64.8734V64.7584C32.5508 64.6841 32.5916 64.6173 32.6547 64.5839L33.2263 64.2499Z",
    fill: "#0020F5"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8532 65.2014V65.361C31.8532 65.4315 31.8123 65.4983 31.7492 65.5354L31.0663 65.9326C31.0107 65.966 30.9438 65.9252 30.9438 65.8621V65.8175L31.5154 65.4835C31.5785 65.4464 31.6193 65.3796 31.6193 65.309V65.194L31.7307 65.1309C31.7864 65.0975 31.8532 65.1383 31.8532 65.2014Z",
    fill: "#80898A"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6193 65.1988V65.3138C31.6193 65.3844 31.5785 65.4512 31.5154 65.4883L30.9438 65.8223V65.7073C30.9438 65.633 30.9847 65.5662 31.0478 65.5328L31.6193 65.1988Z",
    fill: "#0020F5"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4489 65.8241L10.9834 65.5977V66.1321C14.4128 70.2259 22.1068 72.553 22.1068 72.553L22.979 72.4046L23.4095 72.6532L22.3851 73.2842C22.3851 73.2842 9.95527 69.6989 9.95899 66.1098L10.4526 65.8241H10.4489Z",
    fill: "#E1F0F0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4093 72.6487L23.0938 75.6921L22.834 75.848C22.6819 75.9408 22.5074 75.9853 22.333 75.9742C22.1919 75.9705 22.0472 75.9334 21.9247 75.8628L14.2048 71.8062L10.2817 69.1376C10.0776 69.0262 9.95508 68.811 9.95508 68.5771V66.1016C14.8691 71.216 21.9247 73.0124 21.9247 73.0124C22.0472 73.0829 22.1919 73.12 22.333 73.1237C22.5074 73.1349 22.6781 73.0903 22.834 72.9975L23.4093 72.645V72.6487Z",
    fill: "#99AFBA"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4093 72.6521L23.0939 75.6956L22.8341 75.8515C22.6819 75.9443 22.5074 75.9888 22.333 75.9777V73.1272C22.5074 73.1383 22.6782 73.0938 22.8341 73.001L23.4093 72.6484V72.6521Z",
    fill: "#CEDBDB"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0938 75.1911L22.834 75.3507C22.5557 75.5214 22.2068 75.5251 21.9247 75.3618C21.9247 75.3618 13.2323 71.7394 9.95508 68.451V68.5809C9.95508 68.811 10.111 68.9817 10.278 69.1413C13.7482 72.4297 21.9247 75.8629 21.9247 75.8629C22.2068 76.0262 22.5557 76.0224 22.834 75.8517L23.0938 75.6921L23.1458 75.1614L23.0938 75.1874V75.1911Z",
    fill: "#D84E42"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2075 73.8704C17.0071 73.7813 16.8438 73.529 16.8438 73.3063V72.1854C16.8438 71.9664 17.0071 71.8625 17.2075 71.9516L19.9132 73.1689C20.1136 73.258 20.2769 73.5104 20.2769 73.7331V74.854C20.2769 75.0729 20.1136 75.1806 19.9132 75.0878L17.2075 73.8704Z",
    fill: "#8B8B8B"
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3149 73.6712C17.1145 73.5821 16.9512 73.3298 16.9512 73.1071V71.9862C16.9512 71.7672 17.1145 71.6633 17.3149 71.7524L20.0206 72.9697C20.221 73.0588 20.3843 73.3112 20.3843 73.5339V74.6548C20.3843 74.8737 20.221 74.9814 20.0206 74.8886L17.3149 73.6712Z",
    fill: "#F9FCFC"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2075 73.7181C17.0071 73.629 16.8438 73.3766 16.8438 73.1539V72.0331C16.8438 71.8141 17.0071 71.7102 17.2075 71.7992L19.9132 73.0166C20.1136 73.1057 20.2769 73.3581 20.2769 73.5808V74.7016C20.2769 74.9206 20.1136 75.0283 19.9132 74.9355L17.2075 73.7181Z",
    fill: "#E0E0E0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9133 74.8642L17.2076 73.6468C17.0443 73.5726 16.9106 73.3684 16.9106 73.1903V72.0694C16.9106 71.8912 17.0443 71.8059 17.2076 71.8801L19.9133 73.0975C20.0766 73.1717 20.2102 73.3758 20.2102 73.554V74.6749C20.2102 74.853 20.0766 74.9384 19.9133 74.8642Z",
    fill: "#F8FFFF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2062 73.5428C20.2062 73.3646 20.0726 73.1679 19.913 73.0937L17.2073 71.8763C17.0477 71.8021 16.9178 71.8874 16.9141 72.0582L20.2062 73.5391V73.5428Z",
    fill: "#6BB5FF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9141 73.199C16.9178 73.3772 17.0477 73.5739 17.2073 73.6481L19.913 74.8655C20.0726 74.9397 20.2025 74.8543 20.2062 74.6836L16.9141 73.2027V73.199Z",
    fill: "#6BB5FF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8698 54.0552L16.5692 54.2482C16.4875 54.3002 16.4801 54.3892 16.3947 54.341L16.2611 54.2333C16.1683 54.1814 16.0681 53.9847 16.1572 53.929L16.4578 53.7397C16.5395 53.6877 16.8661 53.543 16.9515 53.595L16.9849 53.6098C17.0776 53.6618 16.9552 54.0032 16.8661 54.0552H16.8698Z",
    fill: "#A93E38"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2966 54.096L16.8178 54.4004C16.7251 54.4561 16.61 54.4598 16.5135 54.4004L16.3984 54.3336C16.2945 54.2742 16.4319 53.8474 16.5284 53.788L16.8698 53.7583C16.9626 53.7026 17.1036 53.5542 17.2001 53.6098L17.2781 53.6692C17.382 53.7286 17.3931 54.0329 17.2966 54.0923V54.096Z",
    fill: "#0020F5"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1743 53.8282L16.8737 54.0212C16.792 54.0732 16.6881 54.0732 16.6027 54.0212L16.5656 54.0064C16.4728 53.9544 16.4691 53.8171 16.5582 53.7651L16.8588 53.5759C16.9405 53.5239 17.0444 53.5239 17.1298 53.5759L17.1632 53.5907C17.256 53.6427 17.2597 53.78 17.1706 53.8319L17.1743 53.8282Z",
    fill: "#0020F5"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6164 55.6433L19.3158 55.8363C19.2341 55.8883 19.2267 55.9773 19.1413 55.9291L19.0077 55.8215C18.9149 55.7695 18.8147 55.5728 18.9038 55.5171L19.2044 55.3278C19.2861 55.2759 19.6127 55.1311 19.698 55.1831L19.7314 55.1979C19.8242 55.2499 19.7018 55.5913 19.6127 55.6433H19.6164Z",
    fill: "#A93E38"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0432 55.6861L19.5644 55.9904C19.4716 56.0461 19.3566 56.0498 19.2601 55.9904L19.145 55.9236C19.0411 55.8643 19.1784 55.4374 19.2749 55.3781L19.6164 55.3484C19.7092 55.2927 19.8502 55.1442 19.9467 55.1999L20.0247 55.2593C20.1286 55.3187 20.1397 55.623 20.0432 55.6824V55.6861Z",
    fill: "#0020F5"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9209 55.4165L19.6203 55.6095C19.5386 55.6614 19.4347 55.6614 19.3493 55.6095L19.3122 55.5946C19.2194 55.5426 19.2157 55.4053 19.3048 55.3534L19.6054 55.1641C19.6871 55.1121 19.791 55.1121 19.8764 55.1641L19.9098 55.1789C20.0026 55.2309 20.0063 55.3682 19.9172 55.4202L19.9209 55.4165Z",
    fill: "#0020F5"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3591 57.237L22.0584 57.43C21.9768 57.482 21.9694 57.5711 21.884 57.5228L21.7504 57.4152C21.6576 57.3632 21.5574 57.1665 21.6465 57.1108L21.9471 56.9215C22.0287 56.8696 22.3553 56.7249 22.4407 56.7768L22.4741 56.7917C22.5669 56.8436 22.4444 57.1851 22.3554 57.237H22.3591Z",
    fill: "#A93E38"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7859 57.2759L22.3071 57.5803C22.2143 57.636 22.0993 57.6397 22.0028 57.5803L21.8877 57.5135C21.7838 57.4541 21.9211 57.0273 22.0176 56.9679L22.3591 56.9382C22.4519 56.8825 22.5929 56.7341 22.6894 56.7897L22.7673 56.8491C22.8713 56.9085 22.8824 57.2128 22.7859 57.2722V57.2759Z",
    fill: "#0020F5"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 57.0102L22.3664 57.2032C22.2847 57.2552 22.1808 57.2552 22.0954 57.2032L22.0583 57.1884C21.9655 57.1364 21.9618 56.9991 22.0509 56.9471L22.3515 56.7578C22.4332 56.7059 22.5371 56.7059 22.6225 56.7578L22.6559 56.7727C22.7486 56.8246 22.7524 56.962 22.6633 57.0139L22.667 57.0102Z",
    fill: "#0020F5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9787 61.742L22.2624 65.9656L16.2312 63.0447L15.5705 62.7366L15.5557 62.7292L11.8145 59.9233L12.5271 55.707L13.0615 56.0151L15.4295 57.3883L16.5578 58.0378L17.1999 58.409L22.9787 61.742Z",
    fill: "#538B94"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9809 62.17L16.3202 61.8619L16.3054 61.8545L12.5642 59.0449L11.8961 59.4495L11.8145 59.9245L15.5557 62.7305L15.5705 62.7379L16.2312 63.0459L22.2624 65.9669L22.4554 64.82L16.9809 62.17Z",
    fill: "#75A2A9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4295 57.3889C15.3738 57.4371 15.3144 57.4817 15.2439 57.5188L12.9279 58.8549C12.6978 58.9848 12.4194 58.7881 12.4788 58.5283L12.965 56.3126C12.9873 56.2124 13.017 56.1084 13.0615 56.0156L15.4295 57.3852V57.3889Z",
    fill: "#B5D6C7"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1996 58.4083V58.412L16.5093 63.4188L15.8486 63.1107L16.5575 58.0408V58.0371L17.1996 58.4083Z",
    fill: "#2EA8C6"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1592 67.738C15.1592 67.983 15.4413 68.3355 15.779 68.5211C16.1205 68.7067 16.3914 68.6585 16.3877 68.4135C16.384 68.1685 16.1057 67.8159 15.7679 67.6304C15.4264 67.4448 15.1555 67.493 15.1592 67.738Z",
    fill: "#929DA6"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0254 67.8337C15.0254 68.0787 15.3075 68.4312 15.6453 68.6168C15.9867 68.8024 16.2576 68.7542 16.2539 68.5092C16.2502 68.2642 15.9719 67.9117 15.6341 67.7261C15.2927 67.5405 15.0217 67.5887 15.0254 67.8337Z",
    fill: "#006A92"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8652 71.6528V71.0589C21.8578 70.8659 21.7538 70.6989 21.5868 70.621L20.0577 69.9232L19.7607 69.7896C19.6123 69.7228 19.4304 69.849 19.4341 70.016V70.7323C19.4416 70.9253 19.5492 71.0886 19.7162 71.1666L21.5423 72.0017C21.6907 72.0685 21.8726 71.9423 21.8689 71.7715V71.6491L21.8652 71.6528Z",
    fill: "#BDCEDF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7468 71.8073L19.9208 70.9722C19.7538 70.8942 19.6461 70.7309 19.6461 70.5379V69.8216C19.6461 69.8216 19.6461 69.7882 19.6535 69.7733C19.5385 69.7882 19.4346 69.8884 19.4346 70.0146V70.7309C19.442 70.9239 19.5496 71.0872 19.7166 71.1651L21.5427 72.0002C21.6726 72.0596 21.8248 71.9631 21.8582 71.8221C21.8211 71.8258 21.784 71.8221 21.7506 71.8073H21.7468Z",
    fill: "#6B777F"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8614 71.0597C21.8614 70.8667 21.7538 70.6996 21.5868 70.6217L20.0576 69.9239L19.9834 69.8905V70.3062C19.9908 70.4992 20.0947 70.6625 20.2618 70.7405L21.8651 71.4753V71.0597H21.8614Z",
    fill: "#E2E9EC"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7131 66.7469V66.153C12.7094 65.9563 12.6389 65.7819 12.5238 65.6891L11.4883 64.8317L11.2879 64.6684C11.1877 64.5868 11.0652 64.6944 11.0689 64.8614V65.5814C11.0726 65.7744 11.1469 65.9489 11.2582 66.0417L12.4942 67.0661C12.5944 67.1477 12.7168 67.0401 12.7168 66.8694V66.7469H12.7131Z",
    fill: "#BDCEDF"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6312 66.8915L11.3953 65.8671C11.2839 65.7743 11.2097 65.5961 11.2097 65.4069V64.6868C11.2097 64.6868 11.2097 64.6571 11.2134 64.6386C11.1355 64.6386 11.0649 64.7313 11.0649 64.8612V65.5813C11.0687 65.7743 11.1429 65.9487 11.2542 66.0415L12.4902 67.0659C12.5792 67.1401 12.6795 67.0585 12.7017 66.9211C12.6757 66.9211 12.6535 66.9137 12.6275 66.8951L12.6312 66.8915Z",
    fill: "#6B777F"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M12.713 66.155C12.713 65.9583 12.6388 65.7838 12.5274 65.691L11.4919 64.8337L11.4399 64.7929V65.2123C11.4437 65.4053 11.5179 65.5797 11.6292 65.6725L12.713 66.5707V66.155Z",
    fill: "#E2E9EC"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M21.019 69.7509V69.3649C21.0153 69.2387 20.9448 69.1311 20.8371 69.0791L19.8387 68.6226L19.6457 68.5335C19.5492 68.489 19.4305 68.5744 19.4342 68.682V69.1496C19.4379 69.2758 19.5084 69.3835 19.616 69.4317L20.8074 69.9773C20.9039 70.0218 21.0227 69.9365 21.019 69.8289V69.7509Z",
    fill: "#001ACC"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9414 69.8561L19.75 69.3105C19.6424 69.2622 19.5719 69.1546 19.5719 69.0284V68.5608C19.5719 68.5608 19.5719 68.5385 19.5756 68.5273C19.5014 68.5348 19.4346 68.6053 19.4346 68.6869V69.1546C19.4383 69.2808 19.5088 69.3884 19.6164 69.4367L20.8078 69.9823C20.8932 70.0231 20.9934 69.9563 21.012 69.8672C20.9897 69.8672 20.9637 69.8672 20.9414 69.8561Z",
    fill: "#6B777F"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0153 69.3661C21.0153 69.2399 20.9448 69.1323 20.8372 69.0803L19.8388 68.6238L19.7905 68.6016V68.8725C19.7942 68.9987 19.8648 69.1063 19.9724 69.1546L21.019 69.6334V69.3624L21.0153 69.3661Z",
    fill: "#0020F5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M12.713 65.2452V64.8777C12.713 64.759 12.6647 64.6476 12.5979 64.592L11.9595 64.0649L11.837 63.9647C11.7739 63.9127 11.6997 63.9833 11.6997 64.0835V64.5251C11.6997 64.6439 11.748 64.7515 11.8185 64.8109L12.5793 65.4419C12.6424 65.4938 12.7167 65.4233 12.7167 65.3194V65.2452H12.713Z",
    fill: "#001ACC"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6644 65.3335L11.9036 64.7026C11.8331 64.6432 11.7885 64.5356 11.7885 64.4168V63.9751C11.7885 63.9751 11.7885 63.9566 11.7885 63.9454C11.7403 63.9454 11.6957 64.0048 11.6994 64.0828V64.5244C11.6994 64.6432 11.7477 64.7508 11.8182 64.8102L12.5791 65.4412C12.6347 65.4857 12.6978 65.4375 12.709 65.3521C12.6941 65.3521 12.6793 65.3484 12.6644 65.3372V65.3335Z",
    fill: "#6B777F"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7128 64.878C12.7128 64.7592 12.6683 64.6479 12.5978 64.5922L11.9594 64.0652L11.9297 64.0392V64.2953C11.9297 64.414 11.9779 64.5217 12.0447 64.5811L12.7128 65.1341V64.878Z",
    fill: "#0020F5"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6836 55.5456V66.5243C28.6836 66.8026 29.0325 67.029 29.4593 67.029C29.8861 67.029 30.235 66.8026 30.235 66.5243V55.5196L28.6836 55.5456Z",
    fill: "url(#paint43_linear_188_8464)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2389 55.544C30.2389 55.8223 29.89 56.0487 29.4632 56.0487C29.0364 56.0487 28.6875 55.8223 28.6875 55.544C28.6875 55.2656 29.0364 55.0392 29.4632 55.0392C29.89 55.0392 30.2389 55.2656 30.2389 55.544Z",
    fill: "#E1F0F0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7403 51.2927C30.7885 51.8457 30.358 52.15 30.358 52.15L30.1502 52.3208C29.9683 52.4618 29.8644 52.6845 29.8644 52.9146V55.4236C29.8236 55.5423 29.6565 55.6314 29.4598 55.6314C29.2705 55.6314 29.1147 55.5535 29.0664 55.4384V52.7105C29.0664 52.3096 29.2483 51.9348 29.5563 51.6824L30.4137 50.9104C30.4137 50.9104 30.7069 50.8399 30.744 51.2964L30.7403 51.2927Z",
    fill: "#B9C6C7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M29.229 55.5648V52.8368C29.229 52.436 29.4109 52.0611 29.7189 51.8087L30.5763 51.0367C30.5763 51.0367 30.6171 51.0256 30.6728 51.0367C30.5726 50.866 30.4093 50.9068 30.4093 50.9068L29.5519 51.6788C29.2439 51.9312 29.062 52.3061 29.062 52.7069V55.4349C29.0917 55.498 29.1548 55.5499 29.2402 55.5833C29.2365 55.5759 29.229 55.5685 29.2253 55.5611L29.229 55.5648Z",
    fill: "#DDE2E6"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6061 51.8632L30.1496 52.2752C29.8415 52.5276 29.6597 52.9024 29.6597 53.3033V55.5859C29.7599 55.5487 29.8378 55.4893 29.8638 55.4151V52.9061C29.8638 52.676 29.9677 52.457 30.1496 52.3123L30.3574 52.1416C30.3574 52.1416 30.4948 52.0414 30.6061 51.8558V51.8632Z",
    fill: "#A6A9AB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_8464",
    x1: 20.2923,
    y1: 75.527,
    x2: 37.5583,
    y2: 45.6159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_188_8464",
    x1: 40.1191,
    y1: 45.4791,
    x2: 35.7209,
    y2: 53.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_188_8464",
    x1: 42.2275,
    y1: 46.6666,
    x2: 37.8256,
    y2: 54.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_188_8464",
    x1: 42.3572,
    y1: 52.5499,
    x2: 40.1526,
    y2: 49.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E0E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C0C4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A8ABAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_188_8464",
    x1: 42.6687,
    y1: 49.0853,
    x2: 40.0817,
    y2: 53.5614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_188_8464",
    x1: 41.8007,
    y1: 49.3531,
    x2: 39.9895,
    y2: 52.4857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_188_8464",
    x1: 41.6332,
    y1: 50.4527,
    x2: 40.8092,
    y2: 51.8817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_188_8464",
    x1: 32.5478,
    y1: 49.8523,
    x2: 28.146,
    y2: 57.4758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_188_8464",
    x1: 34.6523,
    y1: 51.0401,
    x2: 30.2541,
    y2: 58.6635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_188_8464",
    x1: 34.7858,
    y1: 56.9234,
    x2: 32.5811,
    y2: 54.2214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E0E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C0C4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A8ABAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_188_8464",
    x1: 35.0937,
    y1: 53.4588,
    x2: 32.5105,
    y2: 57.9349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_188_8464",
    x1: 34.2252,
    y1: 53.7284,
    x2: 32.4177,
    y2: 56.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_188_8464",
    x1: 34.0622,
    y1: 54.8279,
    x2: 33.2345,
    y2: 56.2569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_188_8464",
    x1: 51.2502,
    y1: 51.9478,
    x2: 46.8484,
    y2: 59.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_188_8464",
    x1: 53.3544,
    y1: 53.1334,
    x2: 48.9526,
    y2: 60.7568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_188_8464",
    x1: 53.8299,
    y1: 55.1626,
    x2: 50.9349,
    y2: 60.1732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E0E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C0C4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A8ABAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_188_8464",
    x1: 53.7963,
    y1: 55.5538,
    x2: 51.2094,
    y2: 60.0299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_188_8464",
    x1: 52.9281,
    y1: 55.8221,
    x2: 51.1169,
    y2: 58.9546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#797B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_188_8464",
    x1: 52.7606,
    y1: 56.9215,
    x2: 51.9367,
    y2: 58.3504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_188_8464",
    x1: 43.6747,
    y1: 56.3189,
    x2: 39.2766,
    y2: 63.9424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_188_8464",
    x1: 45.783,
    y1: 57.5064,
    x2: 41.3811,
    y2: 65.1299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_188_8464",
    x1: 46.2579,
    y1: 59.53,
    x2: 43.3629,
    y2: 64.5443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E0E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C0C4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A8ABAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_188_8464",
    x1: 46.2243,
    y1: 59.9216,
    x2: 43.6374,
    y2: 64.4015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_188_8464",
    x1: 45.3521,
    y1: 60.193,
    x2: 43.5446,
    y2: 63.3255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#797B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_188_8464",
    x1: 45.1893,
    y1: 61.2945,
    x2: 44.3617,
    y2: 62.7235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_188_8464",
    x1: 39.6221,
    y1: 52.3662,
    x2: 42.6284,
    y2: 52.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#646668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#85888A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#808385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_188_8464",
    x1: 42.0086,
    y1: 49.5559,
    x2: 40.0674,
    y2: 52.9185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_188_8464",
    x1: 88.536,
    y1: 30.8969,
    x2: 84.1119,
    y2: 38.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_188_8464",
    x1: 89.0147,
    y1: 32.9308,
    x2: 86.1049,
    y2: 37.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E0E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C0C4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A8ABAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_188_8464",
    x1: 88.9775,
    y1: 33.3288,
    x2: 86.3794,
    y2: 37.8272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_188_8464",
    x1: 88.1054,
    y1: 33.599,
    x2: 86.2868,
    y2: 36.7464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_188_8464",
    x1: 87.9384,
    y1: 34.7011,
    x2: 87.1071,
    y2: 36.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_188_8464",
    x1: 80.9239,
    y1: 35.2484,
    x2: 76.5035,
    y2: 42.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_188_8464",
    x1: 81.4026,
    y1: 37.2804,
    x2: 78.4928,
    y2: 42.3206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E0E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C0C4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A8ABAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_188_8464",
    x1: 81.3693,
    y1: 37.6784,
    x2: 78.7713,
    y2: 42.1768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_188_8464",
    x1: 80.4933,
    y1: 37.9506,
    x2: 78.6784,
    y2: 41.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_188_8464",
    x1: 80.33,
    y1: 39.0546,
    x2: 79.4987,
    y2: 40.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_188_8464",
    x1: 28.5869,
    y1: 67.4457,
    x2: 24.185,
    y2: 75.0654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#6C7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#50585E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3B4145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_188_8464",
    x1: 29.0618,
    y1: 69.4671,
    x2: 26.1668,
    y2: 74.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E0E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C0C4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#A8ABAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_188_8464",
    x1: 29.0287,
    y1: 69.8626,
    x2: 26.4418,
    y2: 74.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_188_8464",
    x1: 28.16,
    y1: 70.1342,
    x2: 26.3488,
    y2: 73.2667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#797B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_188_8464",
    x1: 27.993,
    y1: 71.2264,
    x2: 27.1691,
    y2: 72.6553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#919496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B1B5B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ACB0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_188_8464",
    x1: 35.7241,
    y1: 67.9714,
    x2: 33.5825,
    y2: 64.2599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BEC2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#DEE3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D9DEE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_188_8464",
    x1: 28.6836,
    y1: 61.2762,
    x2: 30.2387,
    y2: 61.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BEC2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#DEE3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D9DEE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualOwner);
export default __webpack_public_path__ + "static/media/individual-owner.b968a9dcf5528477d9fc3bafbd528202.svg";
export { ForwardRef as ReactComponent };